import { createAction, createReducer } from '@reduxjs/toolkit'
import { LevelMappingMappedFilter } from 'types';

export type FilterType = {

  jobCategory: number[],
  search: string,
  mapped?: LevelMappingMappedFilter,
}

export const filterInitialState: FilterType = {
  jobCategory: [],
  search: '',
  mapped: LevelMappingMappedFilter.ALL,
};

const initialState: {
  planId: number | null,
  filter: FilterType,
} = {
  planId: null,
  filter: filterInitialState,
};

export const setFilter = createAction<FilterType>('MAPPING_LEVEL_COMPANY/SET_FILTER');

export const resetFilter = createAction('MAPPING_LEVEL_COMPANY/RESET_FILTER');

export const setPlanId = createAction<number>('MAPPING_LEVEL_COMPANY/SET_PLAN_ID');

export const levelMappingReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setFilter, (state, action) => {
      state.filter = action.payload;
    })
    .addCase(resetFilter, (state) => {
      state.filter = filterInitialState;
    })
    .addCase(setPlanId, (state, action) => {
      state.planId = action.payload;
    })
});
